export const GET_RESTAURANT_SETTINGS_ERROR = "redux_store:settings.error.get_restaurant";
export const UPDATE_RESTAURANT_SETTINGS_ERROR = "redux_store:settings.error.update_restaurant";

export const GET_EMAIL_SETTINGS_ERROR = "redux_store:settings.error.get_email";
export const UPDATE_EMAIL_SETTINGS_ERROR = "redux_store:settings.error.update_email";

export const GET_OPENING_HOURS_ERROR = "redux_store:settings.error.get_opening_hours";
export const ADD_OPENING_HOUR_ERROR = "redux_store:settings.error.add_opening_hour";
export const UPDATE_OPENING_HOUR_ERROR = "redux_store:settings.error.update_opening_hour";
export const DELETE_OPENING_HOUR_ERROR = "redux_store:settings.error.delete_opening_hour";

export const GET_CUSTOM_EVENTS_ERROR = "redux_store:settings.error.get_custom_events";
export const ADD_CUSTOM_EVENT_ERROR = "redux_store:settings.error.add_custom_event";
export const UPDATE_CUSTOM_EVENT_ERROR = "redux_store:settings.error.update_custom_event";
export const DELETE_CUSTOM_EVENT_ERROR = "redux_store:settings.error.delete_custom_event";

export const GET_MESSAGE_SAMPLES_ERROR = "redux_store:settings.error.get_message_samples";
export const ADD_MESSAGE_SAMPLE_ERROR = "redux_store:settings.error.add_message_sample";
export const UPDATE_MESSAGE_SAMPLE_ERROR = "redux_store:settings.error.update_message_sample";
export const DELETE_MESSAGE_SAMPLE_ERROR = "redux_store:settings.error.delete_message_sample";

export const GET_RESERVATION_CONDITIONS_ERROR = "redux_store:settings.error.get_reservation_conditions";
export const ADD_RESERVATION_CONDITION_ERROR = "redux_store:settings.error.add_reservation_condition";
export const UPDATE_RESERVATION_CONDITION_ERROR = "redux_store:settings.error.update_reservation_condition";
export const DELETE_RESERVATION_CONDITION_ERROR = "redux_store:settings.error.delete_reservation_condition";

export const GET_SPECIAL_OPTION_CATEGORIES_ERROR = "redux_store:settings.error.get_special_option_categories";
export const ADD_SPECIAL_OPTION_CATEGORY_ERROR = "redux_store:settings.error.add_special_option_category";
export const UPDATE_SPECIAL_OPTION_CATEGORY_ERROR = "redux_store:settings.error.update_special_option_category";
export const DELETE_SPECIAL_OPTION_CATEGORY_ERROR = "redux_store:settings.error.delete_special_option_category";

export const GET_SPECIAL_OPTIONS_ERROR = "redux_store:settings.error.get_special_options";
export const ADD_SPECIAL_OPTION_ERROR = "redux_store:settings.error.add_special_option";
export const UPDATE_SPECIAL_OPTION_ERROR = "redux_store:settings.error.update_special_option";
export const DELETE_SPECIAL_OPTION_ERROR = "redux_store:settings.error.delete_special_option";



// WEBPACK FOOTER //
// ./src/errors/settings.js